var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upsell-popup-container"},[_vm._t("close"),_vm._v(" "),_c('div',{staticClass:"row m-0 w-100"},[_c('div',{staticClass:"col-md-12 p-0"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"row m-0 w-100"},[_c('div',{staticClass:"col-md-12 p-0"},[_vm._t("image")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }